import { getUrl, sessionExpired } from '../setEnvironment';

class DataRetentionAPI {
  constructor() {
    this.URL = getUrl();
    this.getPolicies = this.getPolicies.bind(this);
    this.updatePolicy = this.updatePolicy.bind(this);
    this.getSettings = this.getSettings.bind(this);
    this.updateSettings = this.updateSettings.bind(this);
  }

  async getPolicies(token) {
    try {
      const response = await fetch(this.URL + '/data-retention/policies', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: token },
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (error) {
      throw error;
    }
  }

  async updatePolicy(token, id, fields) {
    try {
      const response = await fetch(this.URL + '/data-retention/policies/' + id, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({ ...fields }),
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (error) {
      throw error;
    }
  }

  async getSettings(token) {
    try {
      const response = await fetch(this.URL + '/data-retention/settings', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: token },
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (error) {
      throw error;
    }
  }

  async updateSettings(token, fields) {
    try {
      const response = await fetch(this.URL + '/data-retention/settings', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({ ...fields }),
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      if (!response.ok) throw new Error(json.message);
      return json;
    } catch (error) {
      throw error;
    }
  }
}

let _dataRetentionAPI = null;

const initDataRetentionAPI = () => {
  if (!_dataRetentionAPI) {
    _dataRetentionAPI = new DataRetentionAPI();
  }
  return _dataRetentionAPI;
};

const getDataRetentionAPI = () => {
  return initDataRetentionAPI();
};

export { initDataRetentionAPI, getDataRetentionAPI };
